{
  "edit": {
    "name": "Имя *"
  },
  "outfitEdit": {
    "name": "Название *",
    "namePlaceholder": "Повседневный, Парадный, Зима…",
    "description": "Описание (одежда, обувь, аксессуары; этот блок попадёт в промпт референса)",
    "kind": "Тип образа",
    "kinds": {
      "garment": {
        "title": "Одежда",
        "hint": "Только вещи на невидимом манекене, без головы. Героя одеваем в шоте."
      },
      "on_character": {
        "title": "Образ на герое",
        "hint": "Герой целиком в этой одежде, с лицом. Для сложного костюма, грима и причёски."
      }
    }
  },
  "correction": {
    "title": "Корректировка референса",
    "hint": "Опишите что нужно изменить — на основе текущего изображения будет сгенерирована новая версия",
    "placeholder": "Например: сделай волосы темнее, добавь очки, измени выражение лица на более серьёзное...",
    "submitting": "Отправка…",
    "generate": "Сгенерировать"
  },
  "promptPreview": {
    "title": "Промпт референса",
    "outfitSuffix": " · образ «{{name}}»",
    "building": "Строю промпт…",
    "failed": "Не удалось: {{error}}",
    "systemPrompt": "Системный промпт",
    "userPrompt": "Пользовательский промпт"
  },
  "references": {
    "title": "Версии референса",
    "base": " · базовый",
    "scopeHeadlessSuffix": " · без головы",
    "outfitSuffix": " · образ «{{name}}»",
    "hint": "Выберите активную версию из сгенерированных ранее.",
    "upload": "Загрузить файл",
    "loading": "Загружаем версии…",
    "empty": "Ещё нет версий. Сгенерируйте референс с карточки героя.",
    "noPreview": "Нет превью",
    "active": "Активна",
    "uploaded": "Загружено",
    "generated": "Сгенерировано",
    "cleared": "Очищено",
    "correct": "Корректировать",
    "makeActive": "Сделать активной",
    "delete": "Удалить",
    "deleteConfirm": "Удалить эту версию референса?"
  },
  "characterSheet": {
    "versionsTitle": "Версии листа · {{name}}",
    "versionsHint": "Выберите активную версию листа героя.",
    "versionsEmpty": "Ещё нет версий. Создайте лист с панели действий.",
    "noPreview": "Нет превью"
  },
  "characterEmotionSheet": {
    "versionsTitle": "Версии листа эмоций · {{name}}",
    "versionsHint": "Выберите активную версию листа эмоций.",
    "versionsEmpty": "Ещё нет версий. Сгенерируйте лист с панели действий.",
    "noPreview": "Нет превью"
  }
}
